export default {
    welcome: "<strong>ยินดีต้อนรับ</strong><br /> สู่สิทธิพิเศษสำหรับคุณ",
    redeemHistory: "ประวัติการรับสิทธิ์",
    outOfStock: "ขออภัย <br /> สิทธิพิเศษหมด",
    buttons: {
        redeenNow: "กดรับสิทธิ์",
        showDetail: "รายละเอียด"
    },
    redeemable: "สิทธิพิเศษคงเหลือ x{0}",
}
